import { Component } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { OfflineService } from '../shared/offline.service'
import { SideBarComponent } from './shared/sidebar/side-bar-component'
import { SideBarService } from './shared/sidebar/side-bar.service'

@Component({
  selector: 'app-customer-area',
  templateUrl: './customer-area.component.html',
  styleUrls: ['./customer-area.component.scss']
})
export class CustomerAreaComponent extends SideBarComponent {

  basketOpened: boolean = false
  isOnline: boolean = true

  constructor(
    protected sideBarService: SideBarService,
    protected router: Router,
    protected route: ActivatedRoute,
    private offlineService: OfflineService
  ) {
    super(sideBarService, router, route)
    this.offlineService.isOnline().subscribe(res => this.isOnline = res)
  }

  ngOnInit() {
    this.sideBarService.basketOpened.subscribe(basketOpened => this.basketOpened = basketOpened)
  }

  closeBasket() {
    this.router.navigate([
      {
        outlets: {
          sidebar: null,
          basket: null
        }
      }], {
      relativeTo: this.route
    }).then(res => this.sideBarService.closeBasket(), error => { })
  }
}
